import React from 'react';
import './index.css';
import Footer from '../../About/Footer';
const aboutStats = [
  {
    value: "50K+",
    label: "People Thriving with us",
    desc: "as a Community, navigating growth and leading Impact"
  },
  {
    value: "46+",
    label: "Cities in India Covered",
    desc: "with our Community Members"
  },
  {
    value: "5+",
    label: "Innovative Products Launched",
    desc: "within our umbrella on segments of Education, Business, and Latest Technology"
  },
  {
    value: "3+",
    label: "Ongoing Innovation Projects",
    desc: "to Bring Innovation and Technology as the core to us"
  }
];

const EmployabilityResearchImpact = () => {
  return (
    <div className="employability-research-wrapper">
      
      {/* --- Section 1: About Markoknow Stats  --- */}
      <section className="mk-about-section">
        <div className="stats-container">
          <div className="stats-left">
            <h2 className="mk-about-heading">
              "We Believe in Driving <span className="mk-blue-text">Impact - Growth - Change</span> to help our People lead with Latest Trends"
            </h2>
            <p className="mk-about-desc">
              By truly empowering our People as - Business Leaders & Professionals, we aim to keep them ahead in the trend, Adapt Faster and Better, Lead the Growth and Create Lasting Impact.
            </p>
          </div>
          <div className="stats-right">
            <h3 className="mk-about-title">About Markoknow</h3>
            <div className="mk-about-grid">
              {aboutStats.map((item, index) => (
                <div key={index} className="mk-stat-item">
                  <h4 className="mk-stat-value">{item.value}</h4>
                  <h5 className="mk-stat-label">{item.label}</h5>
                  <p className="mk-stat-desc">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* --- Section 2: Research Initiative  --- */}
      <section className="research-section">
        <div className="research-container">
          <div className="research-quote-block">
            <div className="quote-icon">“</div>
            <div className="quote-text">
              <p>At Markoknow, we believe employability should not be a privilege shaped by geography, background, or access — it should be a fundamental outcome of education.</p>
              <p>Our work is rooted in a long-term research initiative focused on understanding why employability gaps persist and how meaningful career readiness can be built at the grassroots level.</p>
            </div>
          </div>

          <div className="research-details-grid">
            <div className="research-col">
              <h3 className="col-title">The Problem We’re Studying</h3>
              <p className="col-intro">Despite the growth of education and digital learning, a large section of society remains:</p>
              <ul className="research-list">
                <li>Underprepared for real-world work environments</li>
                <li>Disconnected from industry expectations</li>
                <li>Limited by lack of exposure, guidance, and structured pathways</li>
              </ul>
              <p className="col-conclusion">We see employability challenges not as a skills problem alone, but as a systemic gap between learning, opportunity, and application.</p>
            </div>

            <div className="research-col">
              <h3 className="col-title">Our Research Approach</h3>
              <p className="col-intro">We conduct ongoing research across:</p>
              <ul className="research-list">
                <li>Students from diverse academic and socio-economic backgrounds</li>
                <li>Early-career professionals and career switchers</li>
                <li>Employers, mentors, and ecosystem partners</li>
              </ul>
              <p className="col-intro">Our focus areas include:</p>
              <ul className="research-list">
                <li>Skill readiness vs industry demand</li>
                <li>Access to mentorship and decision-making confidence</li>
                <li>Long-term impact of early exposure to practical thinking</li>
                <li>Behavioral and mindset shifts linked to employability outcomes</li>
              </ul>
              <p className="footer-note">This research directly informs how we design our programs, memberships, and community initiatives.</p>
            </div>
          </div>
        </div>
      </section>

      {/* --- Section 3: Impact & Commitment  --- */}
      <section className="mk-impact-section">
        <div className="mk-impact-container">
          <div className="mk-impact-grid">
            <div className="mk-impact-col">
              <h2 className="mk-impact-title">Measuring Real Impact</h2>
              <p className="mk-impact-intro">
                We measure impact not just by participation, but by outcomes.
              </p>
              <p className="mk-impact-subtext">Our key indicators include:</p>
              <ul className="mk-impact-list">
                <li>Improvement in practical decision-making and problem-solving ability</li>
                <li>Increased confidence in career navigation</li>
                <li>Transition from passive learning to applied thinking</li>
                <li>Sustained engagement with skill-building and opportunity creation</li>
              </ul>
              <p className="mk-impact-footer">
                By tracking progress over time, we ensure our work creates durable employability, not short-term placement optics.
              </p>
            </div>

            <div className="mk-impact-col">
              <h2 className="mk-impact-title">Why Deep-Root Work Matters</h2>
              <p className="mk-impact-intro">
                True employability transformation does not happen at the surface level. It requires:
              </p>
              <ul className="mk-impact-list">
                <li>Early intervention</li>
                <li>Consistent exposure</li>
                <li>Community reinforcement</li>
                <li>Systems that support growth over time</li>
              </ul>
              <p className="mk-impact-footer">
                Our belief is simple: when employability is nurtured at the roots, opportunity becomes scalable, inclusive, and lasting.
              </p>
            </div>
          </div>

          <div className="mk-commitment-box">
            <div className="mk-commitment-badge">Our Commitment</div>
            <p className="mk-commitment-text">
              This research is not a one-time study — it is a continuous feedback loop that shapes how Markoknow evolves. Every program we build, every partnership we form, and every member we support is influenced by this belief. Employability must be built where it is needed the most, and measured by the lives it meaningfully impacts.
            </p>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default EmployabilityResearchImpact;